import React from 'react';
import PropTypes from 'prop-types';
import {
  extractCountries,
  filterByCountry as filterOfficesByCountry,
  groupByCity as groupOfficesByCity,
  extractFirstLetters,
  filterByCitiesFirstLetter,
  getCountryByOfficeId,
  getActiveLetterByOfficeId
} from 'redux/models/offices/model';
import {
  PageBlock,
  PageBlockHeader,
  PageBlockContent,
  PageBlockCaption
} from 'theme/components/Layout/Layout';
import OfficePageCountries from '../OfficePageCountries/OfficePageListCountries';
import OfficePageList from '../OfficePageList/OfficePageList';
import OfficePageLetters from '../OfficePageLetters/OfficePageLetters';
import first from 'lodash/first';

const OfficePageContentExtra = ({ selectedOffice, offices }) => {
  const countries = React.useMemo(() => extractCountries(offices, 'Россия'), [offices]);
  const activeCountryInitial = React.useMemo(() => {
    const foundedActiveCountry = getCountryByOfficeId(offices, selectedOffice);
    // Если мы нашли активную страну по офису, то ставим ее, иначе первую
    return foundedActiveCountry || first(countries);
  }, [offices, selectedOffice, countries]);
  const [activeCountry, setActiveCountry] = React.useState(activeCountryInitial);

  const officesByActiveCountry = React.useMemo(() => {
    // Если нет ни одной страны, то пихаем все офисы в один список
    if (countries.length === 0) {
      return offices;
    }
    return filterOfficesByCountry(offices, activeCountry);
  }, [countries, offices, activeCountry]);

  const letters = React.useMemo(() => extractFirstLetters(officesByActiveCountry), [officesByActiveCountry]);
  const activeLetterInitial = React.useMemo(() => {
    const foundedActiveLetter = getActiveLetterByOfficeId(officesByActiveCountry, selectedOffice);
    // Если мы нашли активную букву среди офисов, то ставим ее, иначе берем первую
    return foundedActiveLetter || first(letters);
  }, [officesByActiveCountry, selectedOffice, letters]);
  const [activeLetter, setActiveLetter] = React.useState(activeLetterInitial);

  const officesByActiveLetter = React.useMemo(() => (
    filterByCitiesFirstLetter(officesByActiveCountry, activeLetter)
  ), [activeLetter, officesByActiveCountry]);
  const officesGroupedByCity = React.useMemo(() => (
    groupOfficesByCity(officesByActiveLetter)
  ), [officesByActiveLetter]);

  return (
    <PageBlock>
      <PageBlockHeader isSeparated>
        <PageBlockCaption>
          Дополнительные офисы
        </PageBlockCaption>
        <OfficePageCountries
          countries={countries}
          activeCountry={activeCountry}
          setActiveCountry={setActiveCountry}
        />
      </PageBlockHeader>
      <PageBlockContent>
        <OfficePageLetters
          activeItem={activeLetter}
          setActiveItem={setActiveLetter}
          items={letters}
        />
        <OfficePageList
          selectedOffice={selectedOffice}
          offices={officesGroupedByCity}
        />
      </PageBlockContent>
    </PageBlock>
  );
};

OfficePageContentExtra.propTypes = {
  selectedOffice: PropTypes.number,
  offices: PropTypes.array
};

export default OfficePageContentExtra;
